module.exports = __webpack_public_path__ + "img/light_btn.28370fc3.png";